import socket from "../socket";
export default function (store) {
    socket.on("timer-started", ({ timer }) => {
        store.commit("worktime/updateTimer", timer);
    });
    socket.on("timer-stopped", ({ timer }) => {
        store.commit("worktime/updateTimer", timer);
    });
    socket.on("task-updated", ({ task }) => {
        store.commit("worktime/updateTask", task);
    });
    socket.on("invoice-created", invoice => {
        const range = store.state.bills.range;
        if (!range)
            return;
        // Beispiel: prüfe ob invoice in Range passt
        const createdAt = new Date(invoice.created_at); // muss Feld im Backend sein
        const from = new Date(range.fromDate);
        const to = new Date(range.toDate);
        const inRange = createdAt >= from && createdAt <= to;
        const statusMatch = !range.status || range.status.includes(invoice.status);
        if (inRange && statusMatch) {
            // entweder direkt einfügen …
            store.commit("bills/updateBill", invoice);
            // … oder sicherheitshalber neu laden:
            // store.dispatch("bills/getBills", range);
        }
    });
    socket.on("invoice-updated", invoice => {
        const range = store.state.bills.range;
        if (!range)
            return;
        // Hier reicht meist ein direktes Update:
        store.commit("bills/updateBill", invoice);
    });
}
